import * as React from "react";
import type { SVGProps } from "react";
const SvgDumbbell = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M22 11V9c0-1.1-.9-2-2-2h-1c0-1.1-.9-2-2-2h-1c-1.1 0-2 .9-2 2v4h-4V7c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2H4c-1.1 0-2 .9-2 2v2c-.55 0-1 .45-1 1s.45 1 1 1v2c0 1.1.9 2 2 2h1c0 1.1.9 2 2 2h1c1.1 0 2-.9 2-2v-4h4v4c0 1.1.9 2 2 2h1c1.1 0 2-.9 2-2h1c1.1 0 2-.9 2-2v-2c.55 0 1-.45 1-1s-.45-1-1-1M4 15V9h1v6zm4 2H7V7h1zm9 0h-1V7h1zm3-2h-1V9h1z"
    />
  </svg>
);
export default SvgDumbbell;
